module.exports = __webpack_public_path__ + "static/media/gold_floor.13c48d6b.png";